(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestseller-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updateCartCount() {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll('.cart-link__count, [data-cart-count]').forEach((el) => {
            el.textContent = cart.item_count > 0 ? cart.item_count : '';
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        })
        .catch(() => {});
    }

    function openCartDrawer(opener) {
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh')
      );
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:open', {
          detail: { opener: opener || null },
        })
      );
    }

    function handleQuickAdd(button) {
      if (button.disabled) return;
      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.disabled = true;
      button.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(() => {
          updateCartCount();
          openCartDrawer(button);
          button.classList.remove('is-loading');

          const label = button.querySelector('[data-quick-add-label]');
          if (label) {
            const originalText = label.textContent;
            label.textContent = button.dataset.addedLabel || 'Added!';
            setTimeout(() => {
              label.textContent = originalText;
              button.disabled = false;
            }, 1800);
          } else {
            button.dataset.state = 'success';
            setTimeout(() => {
              delete button.dataset.state;
              button.disabled = false;
            }, 1800);
          }
        })
        .catch((err) => {
          button.disabled = false;
          button.classList.remove('is-loading');
          console.error(err);
        });
    }

    document.querySelectorAll('.bestseller-carousel [data-quick-add]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        handleQuickAdd(btn);
      });
    });

    document.querySelectorAll('[data-bestseller-track]').forEach((track) => {
      const section = track.closest('.bestseller-carousel');
      const prevBtn = section.querySelector('[data-bestseller-prev]');
      const nextBtn = section.querySelector('[data-bestseller-next]');
      const progressThumb = section.querySelector('[data-bestseller-progress]');

      function scrollByItem(direction) {
        const item = track.querySelector('.bestseller-carousel__item');
        if (!item) return;
        const distance = item.getBoundingClientRect().width + 20;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', () => scrollByItem(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByItem(1));

      function updateProgress() {
        if (!progressThumb) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        const trackWidth = progressThumb.parentElement.clientWidth;
        const thumbWidth = progressThumb.clientWidth;
        const maxTranslate = trackWidth - thumbWidth;
        progressThumb.style.transform = `translateX(${ratio * maxTranslate}px)`;
      }

      track.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-featcat-track]').forEach((track) => {
      const section = track.closest('.featured-categories');
      const prevBtn = section.querySelector('[data-featcat-prev]');
      const nextBtn = section.querySelector('[data-featcat-next]');
      const progressThumb = section.querySelector('[data-featcat-progress]');

      function scrollByItem(direction) {
        const item = track.querySelector('.featured-categories__item');
        if (!item) return;
        const distance = item.getBoundingClientRect().width + 1;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', () => scrollByItem(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => scrollByItem(1));

      function updateProgress() {
        if (!progressThumb) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        const trackWidth = progressThumb.parentElement.clientWidth;
        const thumbWidth = progressThumb.clientWidth;
        const maxTranslate = trackWidth - thumbWidth;
        progressThumb.style.transform = `translateX(${ratio * maxTranslate}px)`;
      }

      let rafId = null;
      function pollProgress() {
        updateProgress();
        rafId = requestAnimationFrame(pollProgress);
      }
      function startPolling() {
        if (rafId) return;
        pollProgress();
      }
      function stopPolling() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        updateProgress();
      }

      track.addEventListener('touchstart', startPolling, { passive: true });
      track.addEventListener('touchend', () => setTimeout(stopPolling, 300), { passive: true });
      track.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitchen-builder"] && !Shopify.designMode) return;
  try {
    
  class KitchenBuilder extends HTMLElement {
    connectedCallback() {
      try {
        const variantsScript = this.querySelector('[data-kb-variants]');
        const optionNamesScript = this.querySelector('[data-kb-option-names]');
        this.variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
        this.optionNames = optionNamesScript ? JSON.parse(optionNamesScript.textContent) : [];

        this.selectedOptions = {};
        this.selectedTextChoices = {};
        this.selectedPricedChoices = {};

        this.errorsEl = this.querySelector('[data-errors]');
        this.totalEl = this.querySelector('[data-running-total]');
        this.submitBtn = this.querySelector('[data-add-to-cart]');
        this.qtyInput = this.querySelector('[data-qty-input]');
        this.priceEl = this.querySelector('[data-price-display]');
        this.galleryMain = this.querySelector('[data-gallery-main]');

        this.querySelectorAll('[data-option-group]').forEach((group) => {
          const position = group.dataset.optionPosition;
          const checked = group.querySelector('[data-swatch]:checked');
          if (checked) this.selectedOptions[position] = checked.value;
        });

        this.bindSwatches();
        this.bindTextGroups();
        this.bindPricedGroups();
        this.bindQuantity();
        this.bindSubmit();
        this.bindGallery();

        this.updateAvailability();
        this.updateTotal();
      } catch (err) {
        console.error('Kitchen builder failed to initialize:', err);
      }
    }

    bindSwatches() {
      this.querySelectorAll('[data-swatch]').forEach((input) => {
        input.addEventListener('change', () => {
          const position = input.dataset.optionPosition;
          const group = input.closest('[data-option-group]');
          group.querySelector('[data-selected-label]').textContent = input.value;
          this.selectedOptions[position] = input.value;
          this.updateAvailability();
          this.updateTotal();
          this.updatePriceDisplay();
          this.updateGalleryForVariant();
        });
      });
    }

    bindGallery() {
      this.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (this.galleryMain) this.galleryMain.src = thumb.dataset.full;
        });
      });
    }

    updateGalleryForVariant() {
      const variant = this.getMatchedVariant();
      if (variant && variant.featured_media && this.galleryMain) {
        const thumb = this.querySelector(`[data-gallery-thumb][data-media-id="${variant.featured_media.id}"]`);
        if (thumb) this.galleryMain.src = thumb.dataset.full;
      }
    }

    bindTextGroups() {
      this.querySelectorAll('[data-text-group]').forEach((group) => {
        const label = group.dataset.label;
        group.querySelectorAll('[data-text-choice]').forEach((input) => {
          input.addEventListener('change', () => {
            this.selectedTextChoices[label] = input.value;
            group.removeAttribute('data-invalid');
          });
        });
      });
    }

    bindPricedGroups() {
      this.querySelectorAll('[data-priced-group]').forEach((group) => {
        const label = group.dataset.label;
        group.querySelectorAll('[data-priced-choice]').forEach((input) => {
          input.addEventListener('change', () => {
            const labelEl = input.nextElementSibling;
            const textEl = labelEl ? labelEl.querySelector('.kb-check-text, .label__text-beside-input') : null;
            this.selectedPricedChoices[label] = {
              variantId: input.dataset.variantId,
              price: parseInt(input.dataset.price, 10),
              skipZero: input.dataset.skipZero === 'true',
              text: textEl ? textEl.textContent.trim() : '',
            };
            group.removeAttribute('data-invalid');
            this.updateTotal();
          });
        });
      });
    }

    bindQuantity() {
      const decrease = this.querySelector('[data-qty-decrease]');
      const increase = this.querySelector('[data-qty-increase]');
      if (decrease) {
        decrease.addEventListener('click', (e) => {
          e.preventDefault();
          this.qtyInput.value = Math.max(1, parseInt(this.qtyInput.value, 10) - 1);
          this.updateTotal();
        });
      }
      if (increase) {
        increase.addEventListener('click', (e) => {
          e.preventDefault();
          this.qtyInput.value = parseInt(this.qtyInput.value, 10) + 1;
          this.updateTotal();
        });
      }
      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', () => this.updateTotal());
      }
    }

    getMatchedVariant() {
      const optionCount = this.optionNames.length;
      const selected = [];
      for (let i = 1; i <= optionCount; i += 1) selected.push(this.selectedOptions[i]);
      if (selected.some((v) => !v)) return null;
      return this.variants.find((variant) => (
        (optionCount < 1 || variant.option1 === selected[0]) &&
        (optionCount < 2 || variant.option2 === selected[1]) &&
        (optionCount < 3 || variant.option3 === selected[2])
      )) || null;
    }

    updateAvailability() {
      const optionCount = this.optionNames.length;
      this.querySelectorAll('[data-option-group]').forEach((group) => {
        const position = parseInt(group.dataset.optionPosition, 10);
        group.querySelectorAll('[data-swatch]').forEach((input) => {
          const label = group.querySelector(`label[for="${input.id}"]`);
          const testSelection = [];
          for (let i = 1; i <= optionCount; i += 1) {
            testSelection.push(i === position ? input.value : this.selectedOptions[i]);
          }
          const anyAvailable = this.variants.some((variant) => (
            testSelection.every((val, idx) => {
              if (!val) return true;
              return variant['option' + (idx + 1)] === val;
            })
          ));
          if (label) label.classList.toggle('kb-swatch--unavailable', !anyAvailable);
        });
      });
    }

    updateTotal() {
      if (!this.qtyInput) return;
      const variant = this.getMatchedVariant();
      let total = variant ? variant.price : 0;
      Object.values(this.selectedPricedChoices).forEach((choice) => { total += choice.price; });
      const qty = Math.max(1, parseInt(this.qtyInput.value, 10) || 1);
      total *= qty;
      if (this.totalEl) this.totalEl.textContent = this.formatMoney(total);
      this.syncVitalsStickyPrice(total);
    }

    syncVitalsStickyPrice(total) {
      const priceEl = document.querySelector('.Vtl-StickyAddToCart__ProductPrice');
      if (!priceEl) return;
      this.vitalsPriceText = this.formatMoney(total);
      this.applyVitalsPriceText(priceEl);
      this.observeVitalsPriceEl(priceEl);
    }

    findDeepestTextEl(el) {
      if (!el.children || el.children.length === 0) return el;
      for (const child of el.children) {
        const found = this.findDeepestTextEl(child);
        if (found) return found;
      }
      return el;
    }

    applyVitalsPriceText(priceEl) {
      const target = this.findDeepestTextEl(priceEl);
      if (target && target.textContent !== this.vitalsPriceText) {
        target.textContent = this.vitalsPriceText;
      }
    }

    observeVitalsPriceEl(priceEl) {
      if (this.vitalsObserver) return;
      this.vitalsObserver = new MutationObserver(() => {
        this.applyVitalsPriceText(priceEl);
      });
      this.vitalsObserver.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }

    updatePriceDisplay() {
      if (!this.priceEl) return;
      const variant = this.getMatchedVariant();
      if (!variant) return;
      const compare = variant.compare_at_price;
      let html = `<span class="price__current">${this.formatMoney(variant.price)}</span>`;
      if (compare && compare > variant.price) {
        html = `<span class="price__was">${this.formatMoney(compare)}</span>` + html;
      }
      this.priceEl.innerHTML = `<div class="price${compare && compare > variant.price ? ' price--on-sale' : ''}"><div class="price__default">${html}</div></div>`;
    }

    formatMoney(cents) {
      const format = this.dataset.moneyFormat || '£{{amount}}';
      const amount = (cents / 100).toFixed(2);
      const amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const amountNoDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return format
        .replace(/\{\{\s*amount\s*\}\}/, amountWithCommas)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amountWithCommas)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, amountNoDecimals);
    }

    validate() {
      const errors = [];
      const variant = this.getMatchedVariant();
      if (!variant) {
        errors.push('Please select an option for every choice above.');
      } else if (!variant.available) {
        errors.push('That combination is currently unavailable.');
      }

      this.querySelectorAll('[data-text-group][data-required="true"]').forEach((group) => {
        const label = group.dataset.label;
        if (!this.selectedTextChoices[label]) {
          group.setAttribute('data-invalid', '');
          errors.push(label + ' is required.');
        }
      });

      this.querySelectorAll('[data-priced-group][data-required="true"]').forEach((group) => {
        const label = group.dataset.label;
        if (!this.selectedPricedChoices[label]) {
          group.setAttribute('data-invalid', '');
          errors.push(label + ' is required.');
        }
      });

      return { valid: errors.length === 0, errors, variant };
    }

    bindSubmit() {
      if (!this.submitBtn) return;
      this.submitBtn.addEventListener('click', () => {
        const { valid, errors, variant } = this.validate();

        if (!valid) {
          this.errorsEl.hidden = false;
          this.errorsEl.innerHTML = errors.map((e) => `<div>${e}</div>`).join('');
          this.errorsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.errorsEl.hidden = true;
        this.submitBtn.disabled = true;

        const qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;
        const buildId = 'kb_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);

        const mainProperties = { '_kitchen_build_id': buildId };
        Object.entries(this.selectedTextChoices).forEach(([label, value]) => {
          mainProperties[label] = value;
        });

        const items = [];

        Object.entries(this.selectedPricedChoices).forEach(([label, choice]) => {
          if (choice.price === 0) {
            mainProperties[label] = choice.text;
          }
        });

        items.push({ id: variant.id, quantity: qty, properties: mainProperties });

        Object.entries(this.selectedPricedChoices).forEach(([label, choice]) => {
          if (choice.price === 0) return;
          items.push({
            id: choice.variantId,
            quantity: qty,
            properties: {
              '_kitchen_build_id': buildId,
              'Part of': this.dataset.productHandle,
              'Component': label,
            },
          });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(() => {
            fetch('/cart.js')
              .then((r) => r.json())
              .then((cart) => {
                document.querySelectorAll('.cart-link__count, [data-cart-count]').forEach((el) => {
                  el.textContent = cart.item_count > 0 ? cart.item_count : '';
                });
              })
              .catch(() => {});

            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
            document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

            this.submitBtn.disabled = false;
          })
          .catch((err) => {
            this.errorsEl.hidden = false;
            this.errorsEl.innerHTML = '<div>Something went wrong adding this to your cart. Please try again.</div>';
            this.submitBtn.disabled = false;
            console.error(err);
          });
      });
    }
  }

  customElements.define('kitchen-builder', KitchenBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
